import { Component, EventEmitter, input, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mcg-button',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './button.component.html',
  styleUrl: './button.component.css'
})
export class ButtonComponent {
  /**
   * The visible text on the button.
   */
  public label = input.required<string>();

  /**
   * Optional prefix icon name
   */
  public prefixIconName = input<string>();

  /**
   * Optional prefix icon name
   */
  public suffixIconName = input<string>()

  /**
   * Wether the button is disabled.
   */
  public disabled = input<boolean>(false);

  /**
   * Button size (small, medium, big)
   *
   * small: font-size: 14px, icon-size: 16px
   * medium: font-size: 14px, icon-size: 16px, padding: +0.5em
   * big: font-size: 16px, icon-size: 20px, padding: +1em
   */
  public size = input<string>('medium');

  /**
   * Button type (button, submit, reset)
   */
  public type = input<string>('button');

  private sizeMap: Record<string, number> = {
    small: 16,
    medium: 16,
    big: 20
  };

  /**
  * Event emitted when the button is clicked.
  */
  @Output() public clicked = new EventEmitter<void>();


  /**
   * Returns the icon name to use (prefix prioritized over suffix)
   */
  public iconName(): string | null {
    return this.prefixIconName() ?? this.suffixIconName() ?? null;
  }

  public iconSize(): number {
    return this.sizeMap[this.size()] ?? 16;
  }
}
